<template lang="pug">
  div.rails
    div.rail(v-for="(n, i) in slititems",:style="sty()")
</template>

<script>
export default {
  name: 'SizeWidth',
  components: {
  },
  data () {
    return {
    };
  },
  props: {
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    }
  },
  methods: {
    update () {
      // すべて更新
      if (this.sets !== undefined) {
        this.set = this.sets[this.number];
        if (this.sets.length > 0 && this.set !== undefined) {
          this.width = this.set.size[0];
          this.height = this.set.size[1];
          this.depth = this.set.size[2];
        }
      }
    },
    sty () {
      let bg;
      this.color = this.sets[this.number].color;
      if (this.color === 1) {
        bg = '#32353a';
      } else {
        bg = '#ffffff';
      }
      return {
        backgroundColor: bg
      };
    }
  },
  created () {
    this.update();
  }
};
</script>

<style lang="stylus" scoped>
  .rails
    position absolute
    left 0
    top 0
    z-index 2
    .rail
      position absolute
      width 3px
      height 10px
      // border 1px solid #cccccc
      background-color #ffffff
      box-shadow 1px 1px 3px #00000033
      img
        width 100%
        height 100%
        position absolute
        top 0
        left 0
</style>



// WEBPACK FOOTER //
// src/components/side/Rails.vue